(function () {
    "use strict";

    angular.module("app").directive("validateKboNumber", ValidateKboNumberAttribute);

    ValidateKboNumberAttribute.$inject = ["$q", "textValidators"];
    function ValidateKboNumberAttribute($q, textValidators) {
        return {
            require: "ngModel",
            restrict: "A",
            link: function (_scope, _element, _attrs, ctrl) {
                ctrl.$asyncValidators.invalidKboNumber = function (_modelValue, viewValue) {
                    const localPromise = $q.defer();

                    if (!viewValue || ctrl.$pristine) {
                        // Resolve the promise if the field is empty or the model is pristine, otherwise we break the required validator
                        localPromise.resolve();
                        return localPromise.promise;
                    }

                    if (!textValidators.IsValidKboNumber(viewValue)) {
                        localPromise.reject();
                    }
                    else {
                        localPromise.resolve();
                    }

                    return localPromise.promise;
                };
            }
        };
    }
})();